var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50 0.0234375L14.6484 7.32432V17.8901L50 11.5013V0.0234375Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41.2109 28.0274C43.4601 28.0274 45.5142 28.8771 47.0703 30.2717V14.008L50 13.4785V36.8165C50 41.6628 46.0572 45.6056 41.2109 45.6056C36.3646 45.6056 32.4219 41.6628 32.4219 36.8165C32.4219 31.9702 36.3646 28.0274 41.2109 28.0274ZM8.78906 32.422C11.0382 32.422 13.0923 33.2716 14.6484 34.6662V19.8674L17.5781 19.3379V41.211C17.5781 46.0573 13.6354 50.0001 8.78906 50.0001C3.94277 50.0001 0 46.0573 0 41.211C0 36.3647 3.94277 32.422 8.78906 32.422Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.27c4714e91ffd4ef5f2eb3e925f37ceb.svg";
export { ForwardRef as ReactComponent };